import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@/ds'
import type { Stay } from '@/services/reserva'

/** Wi-Fi en un toque (bundle B1 fase 3): nombre de la red y "Copiar clave". */
export function WifiCard({ stay }: { stay: Stay }) {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)
  useEffect(() => {
    if (!copied) return
    const id = setTimeout(() => setCopied(false), 2500)
    return () => clearTimeout(id)
  }, [copied])
  if (!stay.wifi.ssid) return null
  const copy = async () => {
    if (!stay.wifi.password) return
    try {
      await navigator.clipboard.writeText(stay.wifi.password)
      setCopied(true)
    } catch {
      setCopied(false)
    }
  }
  return (
    <div className="estancia__wifi">
      <span className="estancia__wifi-label">{t('v2.estancia.wifi.titulo')}</span>
      <span className="estancia__wifi-ssid">{stay.wifi.ssid}</span>
      {stay.wifi.password && (
        <button type="button" onClick={() => void copy()} className="estancia__wifi-copy">
          <Icon name={copied ? 'check' : 'copy'} size={18} />
          <span role="status">{copied ? t('v2.estancia.wifi.copiada') : t('v2.estancia.wifi.copiarClave')}</span>
        </button>
      )}
    </div>
  )
}
